<template>
  <div class="container">

    <div class="search">
      <p>当前系统中的所有普通用户如下：</p>
      <div>
        <template v-if="!batchingObj.isOn">
          <l-button
            :shape="2"
            value="批量处理"
            color="#3170FF"
            class="bt1"
            @click.native="batchingStart()"
          ></l-button>

          <l-button
            :shape="2"
            value="批量导入"
            color="#3170FF"
            class="bt1"
            @click.native="batchShow()"
          ></l-button>
          <l-button
            :shape="2"
            value="新增用户"
            color="#159BE0"
            class="bt2"
            @click.native="showAddWidnow"
          ></l-button>
        </template>

        <template v-if="batchingObj.isOn">
          <l-button
            :shape="2"
            value="批量删除"
            color="#3170FF"
            class="bt1"
            @click.native="batchingDelete()"
          ></l-button>
          <l-button
            :shape="2"
            value="结束操作"
            color="#159BE0"
            class="bt1"
            @click.native="batchingEnd()"
          ></l-button>
        </template>

        <el-input
          placeholder="请输入内容"
          prefix-icon="el-icon-search"
          v-model="searchContent"
        >
          <template slot="append">
            <span @click="getTableData({page: 1,})">搜索</span>
          </template>
        </el-input>
      </div>
    </div>

    <div class="mainConainer"
      v-loading="batchingObj.loading"
      :element-loading-text="batchingObj.loadingText"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
    >
      <div class="head">
        <div class="circleList">
          <div
            class="circle"
            v-for="(item,index) in 4"
            :key="index"
            :style="index==0?'width:12px;height:12px;':'width:8px;height:8px;'"
          ></div>
        </div>
        <div class="title">当前普通用户数量为：{{total}}人</div>
      </div>

      <div class="content table" cellspacing="0">
        <table>
          <tr>
            <th>
              <div>
                <input
                  type="checkbox"
                  class="checkboxAll"
                  v-model="checkboxAll"
                  @change="selectAll"
                />
                全选
              </div>
              <div @click="pullDown(0)">
                用户姓名
                <i class="el-icon-caret-bottom"></i>
                <eject-select-list class="select" :show.sync="isShowScreen[0]">
                  <p
                    v-for="(item, index) of tableSelect.name"
                    :key="index"
                    :class="{'on':queryObj.name == item.value}"
                    @click="getTableData({name: item.value, number: '',})"
                  >{{item.label}}</p>
                </eject-select-list>
              </div>
            </th>
            <th @click="pullDown(1)">
              编号
              <i class="el-icon-caret-bottom"></i>
              <eject-select-list class="select" :show.sync="isShowScreen[1]">
                <p
                  v-for="(item, index) of tableSelect.number"
                  :key="index"
                  :class="{'on':queryObj.number == item.value}"
                  @click="getTableData({name: '', number: item.value,})"
                >{{item.label}}</p>
              </eject-select-list>
            </th>
            <th>注册账号</th>
            <th @click="pullDown(2)">
              性别
              <i class="el-icon-caret-bottom"></i>
              <eject-select-list class="select" :show.sync="isShowScreen[2]">
                <p
                  v-for="(item, index) of tableSelect.sex"
                  :key="index"
                  :class="{'on':queryObj.sex == item.value}"
                  @click="getTableData({sex: item.value, page: 1,})"
                >{{item.label}}</p>
              </eject-select-list>
            </th>
            <th @click="pullDown(3)">
              所在部门
              <i class="el-icon-caret-bottom"></i>
              <eject-select-list class="select" :show.sync="isShowScreen[3]">
                <p
                  v-for="(item, index) of tableSelect.class"
                  :key="index"
                  :class="{'on':queryObj.class == item.value}"
                  @click="getTableData({class: item.value, page: 1,})"
                >{{item.label}}</p>
              </eject-select-list>
            </th>
            <th @click="pullDown(4)">
              账号状态
              <i class="el-icon-caret-bottom"></i>
              <eject-select-list class="select" :show.sync="isShowScreen[4]">
                <p
                  v-for="(item, index) of tableSelect.status"
                  :key="index"
                  :class="{'on':queryObj.status == item.value}"
                  @click="getTableData({status: item.value, page: 1,})"
                >{{item.label}}</p>
              </eject-select-list>
            </th>
            <th v-if="!batchingObj.isOn">操作</th>
          </tr>

          <template v-if="!batchingObj.isOn">
            <tr
              v-for="(item,index) in userInfo"
              :key="index"
              @click="nowClickRow = item" :style="{ 'background': nowClickRow == item ? '#e0f0ff' : '' }"
            >
              <td>
                <input
                  type="checkbox"
                  v-model="checkbox[index]"
                  @change="selectItem"
                />
                <div class="avatar">
                  <img :src="global.ip+item.avatar" />
                </div>
                <div class="userName">{{item.nickname}}</div>
              </td>
              <td>{{item.studentId}}</td>
              <td>{{item.username}}</td>
              <td>{{item.sex}}</td>
              <td class="deptname">{{item.deptname}}</td>
              <td :style="{color:item.status==0?'':'red'}">{{item.status==0?'正常':'申诉中'}}</td>
              <td>
                <button @click="examine(item)">查看</button>
                <button @click="submitDelete(item.uid)">删除</button>
              </td>
            </tr>
          </template>
        </table>

        <el-pagination
          v-show="!batchingObj.isOn"
          class="page"
          background
          layout="prev, pager, next"
          :total="queryObj.total"
          :page-size="queryObj.pageSize"
          :current-page="queryObj.page"
          @current-change="changePage"
        ></el-pagination>

        <big-data-roll class="data-table" v-if="batchingObj.isOn" :list="userInfo" :rowHeight="57">
          <template v-slot:default="slotProps">
            <table>
              <tr
                v-for="item in slotProps.list"
                :key="item.index"
                @click="nowClickRow = item" :style="{ 'background': nowClickRow == item ? '#e0f0ff' : '' }"
              >
                <td>
                  <input
                    type="checkbox"
                    v-model="checkbox[item.index]"
                    @change="selectItem"
                  />
                  <div class="avatar">
                    <img :src="global.ip + item.avatar" />
                  </div>
                  <div class="userName">{{item.nickname}}</div>
                </td>
                <td>{{item.studentId}}</td>
                <td>{{item.username}}</td>
                <td>{{item.sex}}</td>
                <td class="deptname">{{item.deptname}}</td>
                <td :style="{color:item.status==0?'':'red'}">{{item.status==0?'正常':'申诉中'}}</td>
              </tr>
            </table>
          </template>
        </big-data-roll>

      </div>
    </div>
    <!-- 批量导入 -->
    <l-dialog
      title="批量导入"
      v-show="batch"
      val1="确定"
      class="batch"
      @save="previewUp"
      @cancel="batch=false"
      v-loading="upDataloading"
    >
      <div class="wrap">
        <div class="downloadTemplate">
          <div class="explain">
            <span></span>
            下载模板：
          </div>
          <a
            @click="downloadTemplate()"
          >点击下载</a>
        </div>
        <div class="downloadTemplate" v-show="eUrl">
          <div class="explain">
            <span></span>
            错误原因：
          </div>
          <a
            @click="downloadTemplateE()"
          >点击下载</a>
        </div>
        <div class="uploading">
          <div class="explain">
            <span></span>
            上传文件：
          </div>
          <button
            class="btn"
            @click="upload"
          >上传文件</button>
          <div class="text">{{fileValue}}</div>
          <input
            type="file"
            v-show="false"
            class="fileUpload"
            @change="changeFileValue"
            multiple="multiple"
          />
        </div>
      </div>
    </l-dialog>

    <l-dialog
      title="操作提示"
      v-show="previewObj.show"
      val1="确定"
      class="batch-preview"
      @save="uploading"
      @cancel="previewObj.show=false"
      v-loading="upDataloading"
    >
      <div class="preview-box">
        <p class="p-title">
          本次操作将会新增{{previewObj.addDeptNum}}个班级，
          请确保班级信息正确，检查无误后，点击确定将开始批量导入用户
        </p>

        <el-table
          class="school-box"
          :data="previewObj.data"
          style="width: 100%">
          <el-table-column
            label="班级名称"
            prop="name">
          </el-table-column>
          <el-table-column
            label="状态"
            prop="typeName">
          </el-table-column>
        </el-table>
      </div>
    </l-dialog>

    <dialog-user :show="examineBox.show" :id="examineBox.data.id" :showEdit="true" @edit="edit" @cancel="()=>{examineBox.show=false}"></dialog-user>
    
    <l-dialog
      :show="showHiddenWindow"
      @cancel="hiddenWindow"
      @save="submit"
      title="新增/编辑用户"
      class="addWidnow"
    >
      <div class="wrap">
        <div class="register">
          <div class="explain">注册账号:</div>
          <input
            type="text"
            class="user"
            v-model="user"
            :disabled="isEdit"
          />

          <span style="color: #999;font-size: 0.14rem;margin-left: 0.2rem;">（字母+数字组成）</span>
        </div>

        <div class="setPWD">
          <div class="explain">设置密码:</div>
          <input
            type="password"
            class="PWD"
            v-model="password"
          />

          <button
            class="speedinessSet"
            @click="password=123456;"
          >快速设置</button>
        </div>
        <!--$myMessage('默认密码：123456')-->
        <div class="explain">{{ status == 1 ? '正在申请找回密码，申请理由：' + reason : ''}}</div>

        <div class="userNameAndSex">
          <div class="explain">用户姓名:</div>
          <input
            type="text"
            class="userName"
            v-model="userName"
          />

          <div class="explain1">性别:</div>
          <el-select
            v-model="sexValue"
            placeholder="请选择"
            class="sexArr"
          >
            <el-option
              v-for="(item,index) in sex"
              :key="index"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </div>

        <div class="classAndSerialNumber">
          <div class="explain">部门:</div>
          <el-select
            v-model="classValue"
            placeholder="请选择"
            class="classList"
            @change="selectClass"
          >
            <!--<el-option
              label="暂不选择"
              :value="''"
            ></el-option>-->
            <el-option
              v-for="(item,index) in classList"
              :key="index"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>

          <div
            class="explain1"
          >编号:</div>
          <input
            type="text"
            class="studentId"
            v-model="studentId"
            @input="studentId=studentId.replace(/[^0-9]/g, '')"
          />
        </div>

        <div class="userNameAndSex">
          <div class="explain">手机号码:</div>
          <input
            type="text"
            class="userName"
            v-model="phone"
          />

          <div
            class="explain1"
          >年龄:</div>
          <input
            type="text"
            class="studentId"
            v-model="age"
          />
        </div>

      </div>
    </l-dialog>
  </div>
</template>

<script>
import dialogUser from './dialogUser.vue';
import lDialog from "../../components/lDialog.vue";
export default {
  components: { lDialog, dialogUser },
  data () {
    return {
      nowClickRow: null,
      // 批量导入显示和隐藏
      batch: false,
      // 搜索参数
      searchContent: "",
      //用户姓名筛选
      userNameOptionValue: "",
      // 序号筛选
      serialNumberOptionValue: "",
      // 性别筛选
      sexOptionValue: "",
      // 所在部门筛选
      classOptionValue: "",
      // 账号状态筛选
      userStatusOptionValue: "",
      //用户账号
      user: "",
      // 密码
      password: "",
      // 用户姓
      userName: "",
      reason: '',
      status: '',
      // 电话号码
      phone: "",
      // 年龄
      age: "",
      // 性别
      sexValue: "",
      sex: ["男", "女"],
      // 用户信息
      userInfo: [],
      // 是否全选
      checkboxAll: false,
      checkbox: [
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
      ],
      
      examineBox: {
        show: false,
        data: {
          id: '',
        },
      },
      // 弹窗显示和隐藏
      showHiddenWindow: false,
      // 部门列表
      classList: [],
      classValue: "",
      classSerialNumber: "",
      // 当前页
      page: 1,
      // 总数
      total: 0,
      pageSize: 10,
      // 是否是编辑
      isEdit: false,
      // 编辑的id
      editId: "",
      // 显示和隐藏删除弹窗
      isShow: false,
      // 删除的id
      deleteId: "",
      // 显示和隐藏表格标题的筛选选项
      isShowScreen: [false, false, false, false, false],
      // option中的所有选项
      options: [
        ["", ""],
        ["正序", "倒序"],
        ["全部", "男", "女"],
        [],
        [
          { label: "全部", value: '' },
          { label: "正常", value: 1 },
          { label: "申诉状态", value: 2 },
        ],
      ],
      // 修改的编号
      studentId: "",
      //文件名
      fileValue: "",
      file: "",
      //地址
      site: "",
      upDataloading: false,

      tableSelect: {
        name: [
          { label: '按拼音（正序）', value: 'asc' },
          { label: '按拼音（倒序）', value: 'desc' },
        ],
        number: [
          { label: '正序', value: 'asc' },
          { label: '倒序', value: 'desc' },
        ],
        sex: [
          { label: '全部', value: '' },
          { label: '男', value: '男' },
          { label: '女', value: '女' },
        ],
        class: [],
        status: [
          { label: "全部", value: '' },
          { label: "正常", value: 1 },
          { label: "申诉状态", value: 2 },
        ],
      },
      queryObj: {
        name: '',
        number: '',
        sex: '',
        class: '',
        status: '',

        page: 1,
        pageSize: 10,
        total: 0,
      },

      eUrl: '',
      previewObj: {
        show: false,
        addDeptNum: 0,
        data: []
      },

      batchingObj: {
        isOn: false,
        loading: false,
        loadingText: '',
        dataNum: 0,
      },

    };
  },
  watch: {
  },
  methods: {
    //下载模板
    async getTemplateSite () {
      const { data } = await this.$post("api/msg/usersTemplate");
      this.site = data.data.url;
    },
    downloadTemplate () {
      // this.$saveAs(this.site)
      this.$saveAs(this.global.ip + this.site, /\/.+$/.exec(this.site)[0].replace('/', ''))
    },
    downloadTemplateE () {
      this.$saveAs(this.global.ip + this.eUrl, /\/.+$/.exec(this.site)[0].replace('/', ''))
    },
    batchShow () {
      this.batch = true
      this.eUrl = ''
      this.fileValue = "";
      this.file = null
    },
    // 预览
    previewUp () {
      if (!this.file) {
        this.$myMessage('请选择上传文件');
        return
      }

      const fileInput = this.file
      const formData = new FormData();

      formData.append("excel", fileInput);
      formData.append("uid", JSON.parse(localStorage.getItem("userinfo")).uid);

      this.upDataloading = true
      this.$post('api/msg/analysisImportUsers', formData).then((res) => {
        this.upDataloading = false

        if (res.data.code == "0") {
          

          let deptObj = {}
          this.classList.forEach((item)=>{
            if (!(item.label in deptObj)) {
              deptObj[item.label] = true
            }
          })
          console.log(deptObj)

          let deptList = [],
              addDeptNum = 0
          res.data.data.msg.forEach((item) => {
            let isAdd = !(item.deptname in deptObj)
            addDeptNum += isAdd ? 1 : 0

            if (isAdd) {
              deptList.push({
                name: item.deptname,
                typeName: '新增班级',
              })
            }
          })
          console.log(deptList)

          if (deptList.length == 0) {
            this.uploading()
            return
          }

          this.previewObj.show = true;
          this.previewObj.data = deptList
          this.previewObj.addDeptNum = addDeptNum

        } else {
          this.eUrl = res.data.data.errorfile
          this.$myMessage(res.data.message);
        }
      }).catch(() => {
        this.upDataloading = false
      })
    },

    //确认上传
    uploading () {
      if (!this.file) {
        this.$myMessage('请选择上传文件');
        return
      }

      const fileInput = this.file
      const formData = new FormData();

      formData.append("excel", fileInput);
      formData.append("uid", JSON.parse(localStorage.getItem("userinfo")).uid);

      this.upDataloading = true
      this.$post('api/msg/importUsers', formData).then((res) => {
        this.upDataloading = false
        if (res.data.code == "0") {
          this.$myMessage(res.data.message);
          this.fileValue = "";
          this.file = null
          this.batch = false;
          this.previewObj.show = false;
          this.getTableData();
          this.getClassList()
        } else {
          this.$myMessage(res.data.message);
        }
      }).catch(() => {
        this.upDataloading = false
      })
    },
    // 文件名显示
    changeFileValue (e) {
      let $target = e.target || e.srcElement;
      let file = $target.files[0];
      this.file = file
      console.log(file)
      this.fileValue = file.name
      e.target.value = ''
    },
    //上传文件
    upload () {
      document.querySelector(".fileUpload").click();
    },
    // 表格筛选
    pullDown (index) {
      this.$set(this.isShowScreen, index, !this.isShowScreen[index]);
    },
    // 确认删除
    submitDelete (id) {
      let index = this.checkbox.map((item, index) => {
        if (item) {
          return index;
        }
      });
      index = index.filter((item) => {
        return item !== undefined;
      });
      let deleteId = '',
          content = '是否要删除该用户？'
      if (index.length) {
        content = '是否要删除勾选的' + index.length + '位用户？'
        index.forEach((item) => {
          deleteId += this.userInfo[item].uid + ",";
        });
      } else {
        deleteId = id;
      }

      this.$popup({
        title: '提示',
        content: content,
        saveFoo: () => {
          this.$post("api/msg/deleteUser", {
            deleteUids: deleteId,
          }).then(({ data })=>{
            if (data.code == "0") {
              // 处理删除整页的情况，当不是最后一页时，当前页数减一
              if (1 == this.userInfo.length) {
                // 判断是否为最后一页
                if (this.queryObj.page == Math.ceil(this.queryObj.total / this.queryObj.pageSize)) {
                  this.queryObj.page = this.queryObj.page > 1 ? this.queryObj.page - 1 : 1;
                }
              }
              this.getTableData();
            }
          })
        },
      })
    },

    // 切换分页
    changePage (page) {
      this.queryObj.page = page;
      this.getTableData();
    },
    examine (item) {
      this.user = item.username;
      this.password = item.password;
      this.userName = item.nickname;
      this.reason = item.reason
      this.status = item.status
      this.sexValue = item.sex;
      this.phone = item.phone
      this.age = item.age
      this.classValue = item.deptname;
      this.classSerialNumber = item.deptid;
      this.editId = item.uid;
      this.studentId = item.studentId;

      this.examineBox.show = true
      this.examineBox.data.id = item.uid
    },
    //编辑用户资料
    edit () {
      this.showHiddenWindow = true;
      this.isEdit = true;
    },
    //新增用户
    async submit () {
      if (!this.classSerialNumber) {
        this.$myMessage('部门不能为空')
        return
      }
      if (this.isEdit) {
        const { data } = await this.$post("api/index/reset", {
          id: this.editId,
          pwd: this.password,
          nickname: this.userName,
          dept: this.classSerialNumber,
          sex: this.sexValue,
          phone: this.phone,
          age: this.age,
          studentId: this.studentId,
        });
        if (data.code === "0") {
          this.user = "";
          this.password = "";
          this.userName = "";
          this.classSerialNumber = "";
          this.classValue = "";
          this.sexValue = "男";
          this.studentId = ''
          this.phone = ''
          this.age = ""
          this.isEdit = false;
          this.showHiddenWindow = false;
          this.getTableData();
          this.examineBox.show = false
        }
      } else {
        const { data } = await this.$post("api/index/register", {
          username: this.user,
          pwd: this.password,
          nickname: this.userName,
          deptid: this.classSerialNumber,
          sex: this.sexValue,
          phone: this.phone,
          age: this.age,
          status: 2,
          studentId: this.studentId,
        });
        if (data.code === "0") {
          this.user = "";
          this.password = "";
          this.userName = "";
          this.classSerialNumber = "";
          this.classValue = "";
          this.sexValue = "男";
          this.studentId = ''
          this.phone = ''
          this.age = ""
          this.showHiddenWindow = false;
          this.getTableData();
          this.examineBox.show = false
        }
      }
    },
    //选择部门
    selectClass (value) {
      this.classSerialNumber = value;
    },
    // 获取部门列表
    async getClassList () {
      const { data } = await this.$post("api/msg/someDept");
      let classList = data.data.list.map((item) => {
        return {
          label: item.deptname, value: item.deptid,
        }
      });
      this.classList = classList
      this.tableSelect.class = [{ label: "全部", value: '' }, ...classList]
    },
    //隐藏新增用户弹窗
    hiddenWindow () {
      this.showHiddenWindow = false;
    },
    //显示新增用户弹窗
    showAddWidnow () {
      this.user = "";
      this.password = "";
      this.userName = "";
      this.reason = ''
      this.status = ''
      this.classSerialNumber = "";
      this.classValue = "";
      this.sexValue = "男";
      this.studentId = ''
      this.phone = ''
      this.age = ""
      this.isEdit = false;
      this.showHiddenWindow = true;
    },
    // 单选
    selectItem () {
      this.checkboxAll = this.checkbox.every((item) => {
        return item;
      });
    },
    // 全选
    selectAll () {
      this.checkbox = this.checkbox.map((item) => {
        item = this.checkboxAll;
        return item;
      });
    },
    // 搜索
    getTableData (qObj) {
      qObj = Object.assign(this.queryObj, qObj)

      this.userInfo = []
      this.checkbox.length = 0

      // 批量处理数据
      if (this.batchingObj.isOn) {
        this.batchingGetTableData(qObj)
        return
      }

      this.$post("api/msg/user", {
        curPage: qObj.page,
        pageSize: qObj.pageSize,
        name_desc: qObj.name,
        id_desc: qObj.number,
        sex: qObj.sex,
        deptid: qObj.class,
        status: qObj.status,
        nickname: this.searchContent,
      }).then(({ data }) => {
        this.userInfo = data.data.list;
        this.checkbox.length = this.userInfo.length;
        for (let i = 0; i < this.checkbox.length; i++) {
          this.checkbox[i] = false;
        }

        this.total = data.data.total //data.data.totalnum;
        this.queryObj.total = data.data.total;
      })
    },

    //============================
    // 数据批量操作

    batchingStart () {
      this.batchingObj.isOn = true
      this.batchingObj.loading = true
      this.getTableData()
    },

    batchingEnd () {
      this.batchingObj.isOn = false
      this.batchingObj.loading = false
      this.getTableData({curPage: 1})
    },

    // 确认删除
    batchingDelete () {
      let index = this.checkbox.map((item, index) => {
        if (item) {
          return index;
        }
      });
      index = index.filter((item) => {
        return item !== undefined;
      });

      if (index.length == 0) {
        this.$myMessage('请勾选需要操作的数据')
        return
      }

      let deleteId = '',
          content = '是否要删除勾选的' + index.length + '位用户？'
      index.forEach((item) => {
        deleteId += this.userInfo[item].uid + ",";
      });

      this.$popup({
        title: '提示',
        content: content,
        saveFoo: () => {
          const loading = this.$loading({
            lock: true,
            text: '处理中，请稍等',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          this.$post("api/msg/deleteUser", {
            deleteUids: deleteId,
          }).then(({ data })=>{
            if (data.code == "0") {
              this.getTableData();
            }
            loading.close();
          }).catch((err) => {
            loading.close();
          });
        },
      })
    },

    batchingGetTableData (qObj) {
      this.total = 0
      this.queryObj.total = 0
      this.batchingObj.dataNum = 0
      this.batchingObj.loading = true
      this.batchingObj.loadingText = '获取数据中'

      let nowList = [],
          nowPage = 1,
          pageSize = 200

      let getData = (page = 1) => {

        nowPage = page

        this.$post("api/msg/user", {
          curPage: page,
          pageSize: pageSize,
          name_desc: qObj.name,
          id_desc: qObj.number,
          sex: qObj.sex,
          deptid: qObj.class,
          status: qObj.status,
          nickname: this.searchContent,
        }).then(({ data }) => {
          if (!this.batchingObj.isOn) {
            // 只有在批量处理开启时，才继续执行
            return
          }

          let userInfo = data.data.list || []
          nowList.push(...userInfo)

          this.total = data.data.total
          this.queryObj.total = data.data.total
          this.batchingObj.dataNum += userInfo.length
          this.batchingObj.loadingText = `获取数据中(${ this.batchingObj.dataNum }/${ this.total })`
          
          if (userInfo.length <= 0) {
            console.log('结束')
            this.batchingObj.loading = false

            this.userInfo = nowList.map((item, index)=>{
              return  {
                ...item,
                index,
              }
            })
            this.checkbox.length = this.userInfo.length;
            for (let i = 0; i < this.checkbox.length; i++) {
              this.checkbox[i] = false;
            }

          } else {
            console.log('完成：' + page)
            getData(page + 1)
          }
        }).catch((err) => {
          this.batchingObj.isOn = false
          this.batchingObj.loading = false
        });
      }

      getData(1)

    },

  },
  created () {
    this.getClassList();
    this.getTableData();
    this.getTemplateSite();
  },
  mounted () { },
};
</script>
<style lang="less" scoped>
.container {
  position: relative;
  .affirm {
    z-index: 1;
    text-align: center;
  }

  .mainConainer {
    .head {
      display: flex;
      align-items: center;
      width: 1430px;
      height: 60px;
      margin-top: 20px;
      opacity: 1;
      border-radius: 10px 10px 0 0;
      background: #F0F0F0;
      .circleList {
        display: flex;
        align-items: center;
        margin-left: 65px;
        .circle {
          width: 12px;
          height: 12px;
          margin-right: 5px;
          opacity: 1;
          border-radius: 50%;
          background: #004EFF;
        }

        div:nth-child(2) {
          background: #FF500C;
        }
        div:nth-child(3) {
          background: #159BE0;
        }
        div:nth-child(4) {
          background: #EFBC00;
        }
      }
      .title {
        margin-left: 492px;
      }
    }
    .content {
      position: relative;
      box-sizing: border-box;
      width: 1430px;
      height: 710px;
      padding: 0 35px 0;
      opacity: 1;
      border-radius: 0 0 10px 10px;
      background: #FFFFFF;
      .deptname {
        overflow: hidden;
        // width: 300px;
        // max-width: 300px;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      table {
        width: 100%;
        border-collapse: collapse;
        tr {
          box-sizing: border-box;
          width: 100%;
          height: 56px;
          border-bottom: 1px solid #F0F0F0;
          line-height: 56px;
          &:hover {
            // background-color: #F9F9F9;
          }
          th {
            position: relative;
            text-align: center;
            opacity: 1;
            color: #777777;
            font-family: Microsoft YaHei, Microsoft YaHei-Regular;
            font-size: 14px;
            font-weight: 400;
            input {
              margin-right: 5px;
            }
          }
          td {
            text-align: center;
            /deep/ .el-checkbox-group {
              height: 56px;
            }
          }
          th:nth-child(1) {
            display: flex;
            align-items: left;
            height: 56px;
            padding: 0 0 0 30px;
            text-align: left;
            >div:nth-child(1) {
              margin-right: 20px;
            }
            >div:nth-child(2) {
              position: relative;
            }
          }

          th:nth-child(2), th:nth-child(3), th:nth-child(5), th:nth-child(6), th:nth-child(7) {
            .userNameOption, .serialNumberOption, .sexOption, .classOption, .statusOption {
              position: absolute;
              left: 50%;
              display: block;
              width: 160px;
              transform: translateX(-50%);
              opacity: 1;
              border-radius: 10px;
              background: #FFFFFF;
              box-shadow: 0 3px 7px 0 rgba(0, 0, 0, .35);
            }
            .option {
              line-height: 50px;
            }
          }
          th:nth-child(1), td:nth-child(1) {
            width: 270px;
          }
          th:nth-child(2), td:nth-child(2) {
            width: 160px;            
          }
          th:nth-child(3), td:nth-child(3) {
            width: 200px;
          }
          th:nth-child(4), td:nth-child(4) {
            width: 160px;         
          }
          th:nth-child(5), td:nth-child(5) {
            width: 210px;         
          }
          th:nth-child(6), td:nth-child(6) {
            width: 120px;         
          }
          th:nth-child(7), td:nth-child(7) {
            width: 230px;         
          }

          td:nth-child(1) {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            height: 56px;
            padding: 0 0 0 30px;
            text-align: left;
            >input {
              margin-right: 30px;
            }
            .avatar {
              overflow: hidden;
              width: 36px;
              height: 36px;
              margin-right: 19px;
              opacity: 1;
              border: 2px solid #3170FF;
              border-radius: 50%;
              img {
                width: 100%;
                height: 100%;
                border-radius: 50%;
              }
            }
          }
          td:nth-last-child(1) {
            button {
              width: 80px;
              height: 40px;
              opacity: 1;
              color: #FFFFFF;
              border: 0 none;
              border-radius: 6px;
              font-size: 14px;
              outline: none;
              &:nth-child(1) {
                margin-right: 15px;
                background: #3170FF;
              }
              &:nth-child(2) {
                color: #333333;
                background: #F0F0F0;
              }
            }
          }
        }
      }
    }
  }
  .batch {
    .wrap {
      box-sizing: border-box;
      width: 460px;
      padding: 30px 50px;
      .downloadTemplate, .uploading {
        display: flex;
        align-items: center;
        height: 50px;
        margin-top: 20px;

        .btn {
          display: block;
          width: 100px;
          height: 40px;
          background: #3831FF;
          line-height: 40px;
        }
        .explain {
          font-family: Microsoft YaHei, Microsoft YaHei-Regular;
          font-size: 20px;
          font-weight: 400;
        }
        >a {
          color: -webkit-link;
          cursor: pointer;
          text-decoration: underline;
        }
        .text {
          width: 150px;
          margin-left: 10px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
    }
  }
  .addWidnow {
    /deep/ .btn {
      margin-top: -40px;
    }
    input {
      font-size: 16px;
    }
    /deep/ .el-input__inner {
      font-size: 16px;
      padding-left: 10px;
    }
    .wrap {
      box-sizing: border-box;
      width: 100%;
      padding: 40px 100px 20px 100px;
      .setPWD {
        margin-top: 15px;
      }
      > .explain {
        display: block;
        margin-top: 10px;
        margin-left: 90px;
        text-align: left;
        color: #777777;
        font-family: Microsoft YaHei, Microsoft YaHei-Regular;
        font-size: 14px;
        font-weight: 400;
      }
      .userNameAndSex {
        margin-top: 15px;
      }
      .classAndSerialNumber {
        margin-top: 15px;
      }

      .register, .setPWD, .userNameAndSex, .classAndSerialNumber, .studentId {
        display: flex;
        align-items: center;
        .explainSerialNumber {
          margin: 0 28px 0 19px;
        }
        .serialNumber {
          width: 100px;
          height: 40px;
          opacity: 1;
          border-radius: 4px;
          background: #F0F0F0;
        }

        .sexArr {
          width: 140px;
          height: 40px;
          opacity: 1;
          border-radius: 4px;
          background: #F0F0F0;

          /deep/ .el-input__inner {
            width: 140px;
            height: 40px;
            opacity: 1;
            border: 0 none;
            border-radius: 4px;
            background: #F0F0F0;
            &:focus {
              border: 0 none;
            }
          }
        }
        /deep/.classList {
          width: 240px;
          height: 40px;
          opacity: 1;
          border: 0 none;
          border-radius: 4px;
          background: #F0F0F0;
          .el-input__inner {
            height: 40px;
            opacity: 1;
            border: 0 none;
            border-radius: 4px;
            background: #F0F0F0;
            &:focus {
              border: 0 none;
            }
          }
        }
        > .explain {
          width: 70px;
          padding-right: 10px;
          text-align: right;
          color: #333333;
          font-family: Microsoft YaHei, Microsoft YaHei-Regular;
          font-size: 14px;
          font-weight: 400;
        }
        > .explain1 {
          width: 55px;
          padding-right: 15px;
          text-align: right;
          color: #333333;
          font-family: Microsoft YaHei, Microsoft YaHei-Regular;
          font-size: 14px;
          font-weight: 400;
        }
        input {
          width: 240px;
          height: 40px;
          opacity: 1;
          border: 0 none;
          border-radius: 4px;
          outline: none;
          background: #F0F0F0;
        }
        .PWD {
          width: 240px;
          height: 40px;
          opacity: 1;
          border: 0 none;
          border-radius: 4px;
          outline: none;
          background: #F0F0F0;
        }
        .speedinessSet {
          width: 80px;
          height: 36px;
          margin-left: 25px;
          text-align: center;
          color: #7F7F7F;
          border: 1px solid #C9C9C9;
          border-radius: 6px;
          background: rgba(255, 255, 255, .2);
          font-family: Microsoft YaHei, Microsoft YaHei-Regular;
          font-size: 14px;
          font-weight: 400;
        }
      }
      .studentId {
        width: 140px !important;
      }
    }
  }

  .batch-preview {
    .preview-box {
      width: 500px;
      // height: 550px;
      .p-title {
        padding: 15px 30px;
        font-size: 18px;
        line-height: 30px;
      }
      .school-box {
        height: 360px;
        padding: 0 30px;
        overflow: auto;
      }
    }
  }

  .data-table {
    max-height: 620px;
    // table tr {
    //   position: relative;
    //   height: 57px !important;
    //   border-bottom: none !important;
    //   &::after{		
    //     content:"";
    //     position: absolute;
    //     display: block;
    //     background: #F0F0F0 !important;
    //     width: 100%;
    //     height: 1px;
    //     left: 0;
    //     bottom: 0;
    //   }
    // }
  }
}

</style>